import DeletedComment from './DeletedComment'

export default class DeletedCommentReply extends DeletedComment {

    constructor(meetingCommentId: number, message: string) {
        super(meetingCommentId, message)
    }
}
